import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const Validations = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>
            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%', maxWidth: '800px' }}
            >
                <strong>Response Validations</strong>
                <br /><br />
                HawkClient allows you to perform validations on API responses using a simple and intuitive UI. This helps ensure your APIs return expected data, status codes, and structures.

                <br /><br />
                The <strong>Validation tab</strong> consists of three main fields:
            </Typography>

            <Typography
                component="ul"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    maxWidth: '800px',
                    paddingLeft: '20px',
                    marginTop: '-8px',
                }}
            >
                <li>
                    <strong>Variable / Expression</strong>: The value from the response you want to validate. You can access fields from the <code>response</code> object like:
                    <ul style={{ paddingLeft: '20px' }}>
                        <li><code>response.body.token</code></li>
                        <li><code>response.status</code></li>
                        <li><code>response.statusText</code></li>
                        <li><code>response.headers['content-type']</code></li>
                    </ul>
                </li>
                <li>
                    <strong>Operator</strong>: A dropdown list of comparison operators such as:
                    <ul style={{ paddingLeft: '20px' }}>
                        <li><code>isEqualTo</code>, <code>isNotEqualTo</code></li>
                        <li><code>contains</code>, <code>notContains</code></li>
                        <li><code>isGreaterThan</code>, <code>isLessThan</code></li>
                        <li><code>isString</code>, <code>hasLength</code></li>
                        <li>...and many more</li>
                    </ul>
                </li>
                <li>
                    <strong>Value</strong>: The expected value or condition you want to validate against the expression.
                </li>
            </Typography>

            <img
                src="/validations.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%', maxWidth: '800px' }}
            >
                <strong>Supported Operators</strong>
                <p>Here’s a full list of operators you can use in validations:</p>
                <ul style={{ paddingLeft: '20px' }}>
                    <li>isGreaterThan</li>
                    <li>isGreaterThenOrEqual</li>
                    <li>isEqualTo</li>
                    <li>isNotEqualTo</li>
                    <li>isLessThen</li>
                    <li>isLessThenOrEqual</li>
                    <li>contains</li>
                    <li>notContains</li>
                    <li>startWith</li>
                    <li>endWith</li>
                    <li>matchesRegex</li>
                    <li>between</li>
                    <li>notBetween</li>
                    <li>isEmpty</li>
                    <li>isUnDefined</li>
                    <li>isNull</li>
                    <li>isTrue</li>
                    <li>isFalse</li>
                    <li>isTypeOf</li>
                    <li>isArray</li>
                    <li>isObject</li>
                    <li>isString</li>
                    <li>isNumber</li>
                    <li>isBoolean</li>
                    <li>hasLength</li>
                </ul>

                <p>
                    These validations help you automatically assert correctness of API responses without writing custom scripts.
                </p>
            </Typography>
        </Box>
    )
};

export default Validations;